import React, { PropsWithChildren } from 'react';
import styles from './SwitchWithNotification.module.scss';
import cls from 'classnames';

export function SwitchWithNotification(props: SwitchNotificationProps) {
  return (
    <div className={styles.body}>
      <span className={cls('label-small')}>{props.text}</span>
      <div className={cls(styles.notification, 'text-100')}>{props.children}</div>
    </div>
  );
}

export type SwitchNotificationProps = PropsWithChildren<{ text: string }>;
